export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer
      className="bg-[#F7F8FA] border-t border-[#E5E7EB] py-10 px-6 md:px-10"
      style={{ fontFamily: "Inter, sans-serif" }}
    >
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-6">
        {/* Logo */}
        <a href="/" className="flex items-center gap-2.5 cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/72f77137-917a-4a26-acda-4b5e849ad406.png"
            alt="Noveka AI"
            className="h-[120px] w-[120px] object-contain"
          />
        </a>

        {/* Links */}
        <nav className="flex items-center gap-6">
          {[
            { label: "Services", id: "services" },
            { label: "Industries", id: "industries" },
            { label: "Contact", id: "contact" },
          ].map(({ label, id }) => (
            <button
              key={label}
              onClick={() => scrollTo(id)}
              className="text-sm text-[#6B7280] hover:text-[#1F2933] transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              {label}
            </button>
          ))}
        </nav>

        {/* Tagline */}
        <p className="text-xs text-[#9CA3AF] tracking-wide">
          <strong className="font-medium text-[#6B7280]">Precision Systems.</strong> Seamless Execution.
        </p>
      </div>

      <div className="max-w-6xl mx-auto mt-6 pt-6 border-t border-[#E5E7EB]">
        <p className="text-center text-xs text-[#9CA3AF]">
          &copy; {new Date().getFullYear()} Noveka AI. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
